import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';

import {
  MyCustomerDataHttpAdapter
} from '@features/customer/infrastructure/http/my-customer-data/my-customer-data.http.adapter';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {
  MyCustomerDataUseCasePort
} from '@features/customer/application/use_cases/my-customer-data/my-customer-data.use-case.port';

export const MyCustomerDataHttpProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: MyCustomerDataUseCasePort,
    useClass: MyCustomerDataHttpAdapter
  }
];
